import { render, staticRenderFns } from "./RecommendedAds.vue?vue&type=template&id=d317789a&scoped=true&"
import script from "./RecommendedAds.vue?vue&type=script&lang=ts&"
export * from "./RecommendedAds.vue?vue&type=script&lang=ts&"
import style0 from "./RecommendedAds.vue?vue&type=style&index=0&id=d317789a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d317789a",
  null
  
)

export default component.exports